export default __webpack_public_path__ + "static/media/phone_mockup.23e11d21.png";